import {lazy} from 'react';

export const UserProfileLazy = lazy(() => import(/* webpackChunkName: "userProfile" */ '.'));
